import React from 'react';

const ShowDate = (props: {
	date: string
}) => {
	const { date } = props;
	let tmp = new Date(date)
	let output = tmp.toLocaleDateString("sv-SE",
		{
			weekday: 'short',
			day: 'numeric'
		});
	return (
		<span style={{ color: "#808080" }}>
			{output}
		</span>
	);
};

export default ShowDate;